"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = exports.CheckErrorStyled = exports.CheckStyled = exports.Check = exports.modifiers = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var styled_components_modifiers_1 = require("styled-components-modifiers");

exports.modifiers = {
  darkGray: function darkGray(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.dark_gray, ";\n      .checkbox__IconContainer {\n        border: 1.5px solid ").concat(theme.farmProject.dark_gray, ";\n\n        svg {\n          fill: ").concat(theme.farmProject.dark_gray, ";\n        }\n      }\n    ")
    };
  },
  leftAlign: function leftAlign() {
    return {
      styles: "\n      justify-content: flex-start;\n    "
    };
  },
  small: function small() {
    return {
      styles: "\n      font-size: 0.75rem;\n      font-weight: normal;\n    "
    };
  },
  disabled: function disabled() {
    return {
      styles: "\n      opacity: 0.5;\n      pointer-events: none;\n    "
    };
  }
};
exports.Check = styled_components_1.default.input.attrs({
  className: 'checkbox__input'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & + .checkbox__IconContainer {\n    svg {\n      opacity: ", ";\n    }\n  }\n"])), function (_ref2) {
  var value = _ref2.value;
  return value ? 1 : 0;
});
exports.CheckStyled = styled_components_1.default.label.attrs({
  className: 'component__Checkbox'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  line-height: normal;\n  letter-spacing: 0.023125rem;\n  text-transform: unset;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  .checkbox__input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  .checkbox__IconContainer {\n    font-size: 0.5rem;\n    width: 1rem;\n    height: 1rem;\n    border: 1.5px solid ", ";\n    border-radius: 0;\n    margin-right: 0.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    svg {\n      width: 0.7rem;\n      height: 0.7rem;\n      fill: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.farmProject.font_family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.farmProject.light_gray;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.farmProject.light_gray;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.farmProject.light_gray;
}, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));
exports.CheckErrorStyled = styled_components_1.default.label.attrs({
  className: 'component__Checkbox'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  line-height: normal;\n  letter-spacing: 0.023125rem;\n  text-transform: unset;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.farmProject.font_family;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.farmProject.light_gray;
});
exports.IconContainer = styled_components_1.default.span.attrs({
  className: 'checkbox__IconContainer'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));